export * from './format-date.pipe';
export * from './capitalize-first.pipe';
export * from './replace.pipe';
export * from './truncate-pipe';



// WEBPACK FOOTER //
// ./src/app/common/pipes/index.ts